/**
 * Visit "Not Performed" Drawer (Phase 7.A)
 *
 * ESM replacement for the inline ``<script>`` that used to live in
 * ``templates/office/visits/partials/_not_performed_drawer.html``.
 *
 * The partial keeps a single bespoke widget (the bill-fee checkbox
 * toggling the fee-amount input visibility) that didn't fit the
 * declarative ``[data-action-form]`` walker introduced in Phase 4
 * Vague 3b — so it would have stayed inline. Phase 7 lifts that
 * widget into this module: the partial now ships a wrapper marked
 * with ``data-bespoke-init="visitNotPerformed"`` plus a few
 * ``data-not-performed-*`` translation attributes; ``visit-drawer.js``
 * walks the loaded content for that marker and calls ``init(rootEl)``.
 *
 * Markup contract (the partial is fully inline-JS-free):
 *
 *   <div data-bespoke-init="visitNotPerformed"
 *        data-not-performed-title="Mark Not Performed"
 *        data-not-performed-reason-required="Please enter a reason."
 *        data-not-performed-success="Visit closed as not performed."
 *        data-not-performed-error="Error marking visit as not performed.">
 *     <form id="drawerNotPerformedForm" …>
 *       <textarea id="drawer_not_performed_reason" …></textarea>
 *       <p id="drawerNotPerformedReasonError" class="hidden …"></p>
 *       <input type="checkbox" id="drawer_np_bill_fee" …>
 *       <div id="drawerNpFeeAmountWrapper" class="hidden">
 *         <input id="drawer_np_fee_amount" …>
 *       </div>
 *     </form>
 *     <button id="drawerNotPerformedSubmit" type="submit" …>…</button>
 *   </div>
 *
 * The bill-fee checkbox toggle, drawerLabel update and submit pipeline
 * (validators, fetch, lock/unlock, toast) are handled here. The submit
 * pipeline reuses ``window.wireDrawerActionForm`` from
 * ``utils/forms/drawer-action-form.js`` (same helper as the other drawers).
 */

function initVisitNotPerformedDrawer(rootEl) {
    if (!rootEl) return;
    const ds = rootEl.dataset;

    const titleEl = document.getElementById('drawerLabel');
    if (titleEl && ds.notPerformedTitle) {
        titleEl.textContent = ds.notPerformedTitle;
    }

    const billFeeCheckbox = rootEl.querySelector('#drawer_np_bill_fee');
    const feeWrapper = rootEl.querySelector('#drawerNpFeeAmountWrapper');
    if (billFeeCheckbox && feeWrapper) {
        billFeeCheckbox.addEventListener('change', () => {
            feeWrapper.classList.toggle('hidden', !billFeeCheckbox.checked);
        });
    }

    if (typeof window.wireDrawerActionForm !== 'function') return;
    if (typeof window.requiredFieldValidator !== 'function') return;

    window.wireDrawerActionForm({
        formId: 'drawerNotPerformedForm',
        submitBtnId: 'drawerNotPerformedSubmit',
        validators: [
            window.requiredFieldValidator({
                inputId: 'drawer_not_performed_reason',
                errorId: 'drawerNotPerformedReasonError',
                message: ds.notPerformedReasonRequired || '',
            }),
        ],
        successMessage: ds.notPerformedSuccess || '',
        errorMessage: ds.notPerformedError || '',
        errorContainerId: 'drawerNotPerformedReasonError',
    });
}

if (typeof window !== 'undefined') {
    window.visitDrawerInits = window.visitDrawerInits || {};
    window.visitDrawerInits.visitNotPerformed = initVisitNotPerformedDrawer;
}

export { initVisitNotPerformedDrawer };
